import { createUploadLink } from "apollo-upload-client";
import BASEURL from "../../pages/Utils/Baseurl";

const createProgressUploadLink = (onProgress) =>
  createUploadLink({
    uri: BASEURL,
    fetch: (uri, options) => {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(options.method, uri);

        // Set request headers
        Object.entries(options.headers || {}).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value);
        });

        // Track upload progress
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const percentCompleted = Math.round(
              (event.loaded / event.total) * 100
            );
            onProgress(percentCompleted);
          }
        };

        // Handle response
        xhr.onload = () => {
          resolve(
            new Response(xhr.responseText, {
              status: xhr.status,
              statusText: xhr.statusText,
              headers: { "Content-Type": "application/json" },
            })
          );
        };

        xhr.onerror = () => reject(new Error("Upload failed"));
        xhr.send(options.body);
      });
    },
  });

export default createProgressUploadLink;
